<div class="py-24 sm:py-32">
  <div class="mx-auto max-w-7xl px-6 lg:px-8">
    <div class="mx-auto max-w-2xl lg:text-center" @fadeInScale>
      <h1 class="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl leading-relaxed">
        {{ "home.stats-section.title" | translate }}
      </h1>
      <p class="mt-6 text-lg leading-loose text-gray-600">
        {{ "home.stats-section.description" | translate }}
      </p>
    </div>

    <div class="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none">
      <div *ngIf="loading" class="flex justify-center">
        <div
          class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-600"
        ></div>
      </div>

      <div *ngIf="error" class="text-center text-red-600 p-4">
        <p class="leading-relaxed">{{ 'home.stats-section.error_message' | translate }}</p>
      </div>

      <div
        *ngIf="!loading && !error && webStatus"
        class="flex flex-col lg:flex-row gap-8 items-end"
        @staggerStats
      >
        <!-- First stat (light background) -->
        <div class="w-full lg:w-1/4">
          <div
            class="h-[280px] flex flex-col justify-between rounded-2xl bg-gray-50 p-8 transition-all duration-300 hover:shadow-lg hover:scale-[1.02] cursor-pointer group"
          >
            <dt
              class="text-5xl font-bold tracking-tight text-gray-900 transition-colors duration-300 group-hover:text-indigo-600 leading-relaxed"
            >
              {{ formatNumber(webStatus.customersCount) }}
            </dt>
            <dd class="mt-auto">
              <p class="text-xl font-semibold leading-loose text-gray-900">
                {{ 'home.stats-section.users_on_platform' | translate }}
              </p>
              <p class="mt-2 text-base leading-relaxed text-gray-600">
                {{ "home.stats-section.stats.0.description" | translate }}
              </p>
            </dd>
          </div>
        </div>

        <!-- Second stat (dark background) -->
        <div class="w-full lg:w-1/3">
          <div
            class="h-[380px] flex flex-col justify-between rounded-2xl bg-gray-900 p-8 transition-all duration-300 hover:shadow-lg hover:scale-[1.02] cursor-pointer group"
          >
            <dt
              class="text-5xl font-bold tracking-tight text-white transition-opacity duration-300 group-hover:opacity-80 leading-relaxed"
            >
              {{ formatBillions(webStatus.transactionsAmount) }}
            </dt>
            <dd class="mt-auto">
              <p class="text-xl font-semibold leading-loose text-white">
                {{ "home.stats-section.stats.1.label" | translate }}
              </p>
              <p class="mt-2 text-base leading-relaxed text-gray-400">
                {{ revenueDescription }}
              </p>
            </dd>
          </div>
        </div>

        <!-- Third stat (purple background) -->
        <div class="w-full lg:w-5/12">
          <div
            class="h-[440px] flex flex-col justify-between rounded-2xl bg-indigo-600 p-8 transition-all duration-300 hover:shadow-lg hover:scale-[1.02] cursor-pointer group"
          >
            <dt
              class="text-5xl font-bold tracking-tight text-white transition-opacity duration-300 group-hover:opacity-80 leading-relaxed"
            >
              {{ formatNumber(webStatus.transactionsCount) }}
            </dt>
            <dd class="mt-auto">
              <p class="text-xl font-semibold leading-loose text-white">
                {{ 'home.stats-section.transactions_this_year' | translate }}
              </p>
              <p class="mt-2 text-base leading-relaxed text-indigo-200">
                {{ "home.stats-section.stats.2.description" | translate }}
              </p>
            </dd>
          </div>
        </div>
      </div>
    </div>

    <!-- Call to Action -->
    <div class="mt-24 from-indigo-50 to-purple-50 rounded-3xl p-12" @fadeIn>
      <div class="mx-auto max-w-3xl text-center">
        <h2 class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl leading-relaxed">
          {{ 'home.stats-section.cta.heading' | translate }}
        </h2>
        <p class="mt-6 text-lg leading-loose text-gray-600">
          {{ 'home.stats-section.cta.description' | translate }}
        </p>
        <div class="mt-10 flex flex-wrap justify-center gap-6">
          <a
            routerLink="/pricing"
            class="rounded-md bg-indigo-600 px-8 py-4 text-lg font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 transition-all duration-200 hover:scale-105"
          >
            {{ 'home.stats-section.cta.view_pricing' | translate }}
          </a>
          <a
            routerLink="/contact-us"
            class="rounded-md bg-white px-8 py-4 text-lg font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 transition-all duration-200 hover:scale-105"
          >
            {{ 'home.stats-section.cta.contact_sales' | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
